import Vue from 'vue';
import Vuex from 'vuex';
import momentDuration from 'moment-duration-format';
import * as actions from './actions';
import * as getters from './getters';
import landlord from './modules/landlord/index';
import products from './modules/products/index';
import tenants from './modules/tenants/index';
import parkings from './modules/parkings/index';
import permits from './modules/permits/index';
import user from './modules/user/index';
import accounts from './modules/accounts/index';
import pricingrules from './modules/pricingrules/index';
import conferencerules from './modules/conferencerules/index';
import landlords from './modules/landlords/index';
import zones from './modules/zones/index';
import maps from './modules/maps/index';
import users from './modules/users/index';
import kiosks from './modules/kiosks/index';
import blacklist from './modules/blacklist/index';
import screen from './modules/screen/screen';
import audit from './modules/audit/index';
import payment from './modules/payment/index'

console.log('!!zones', zones);
console.log('!!maps', maps);

Vue.use(Vuex);
Vue.use(momentDuration);

const options = {
  actions,
  getters,
  modules: {
    landlord,
    products,
    tenants,
    permits,
    parkings,
    user,
    accounts,
    pricingrules,
    conferencerules,
    landlords,
    zones,
    maps,
    users,
    kiosks,
    blacklist,
    screen,
    audit,
    payment
  },
};

const store = new Vuex.Store(options);

export default store;
export { options };



// WEBPACK FOOTER //
// ./src/store/index.js